export default {
  required: {
    message : "Town is required",
    fn      : (input)=>  Boolean(input)
  },
}
